module.exports = __webpack_public_path__ + "static/media/recycle.2caf053b.svg";